export const actionTypes = {
  FETCH_TRANSACTIONS: 'FETCH_TRANSACTIONS',
  SET_TRANSACTIONS: 'SET_TRANSACTIONS',
  FETCH_TRANSACTIONS: 'FETCH_TRANSACTIONS',
  SET_TRANSACTIONS: 'SET_TRANSACTIONS',
  FETCH_TOTAL_REVENUE: 'FETCH_TOTAL_REVENUE',
  SET_TOTAL_REVENUE: 'SET_TOTAL_REVENUE'
};

export const fetchTransactions = () => ({
  type: actionTypes.FETCH_TRANSACTIONS,
});

export const setTransactions = data => ({
  type: actionTypes.SET_TRANSACTIONS,
  data,
});




export const fetchTotalRevenue = () => ({
  type: actionTypes.FETCH_TOTAL_REVENUE
});

export const setTotalRevenue = (amount) => ({
  type: actionTypes.SET_TOTAL_REVENUE,
  amount
});